import { render, staticRenderFns } from "./BaseImg.vue?vue&type=template&id=5d782e42&scoped=true"
import script from "./BaseImg.vue?vue&type=script&lang=js"
export * from "./BaseImg.vue?vue&type=script&lang=js"
import style0 from "./BaseImg.vue?vue&type=style&index=0&id=5d782e42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d782e42",
  null
  
)

export default component.exports